// src/pages/help/topics/analyseFondamentale.js
// Guide « Analyse fondamentale ». Contenu validé — toute modification se fait ici.
export const fr = {
  title: "Analyse fondamentale",
  tagline: "Macroéconomie, entreprises, actualités et synthèses IA",
  readMin: 5,
  intro:
    "La partie Analyse fondamentale aide le trader à mieux comprendre les éléments économiques et financiers qui influencent les marchés. Elle centralise plusieurs catégories d'informations pour permettre à l'utilisateur d'avoir une vision plus claire du contexte avant de prendre une décision.",
  brief: [
    "Suivre les indicateurs macro et les décisions des banques centrales",
    "Retrouver les données d'entreprises et les actualités financières",
    "Obtenir une synthèse IA du contexte fondamental",
  ],
  steps: [
    {
      title: "Macroéconomie",
      text: "Inflation, taux d'intérêt, emploi, croissance, décisions des banques centrales et autres indicateurs importants.",
    },
    {
      title: "Entreprises",
      text: "Activité, performances, résultats financiers et événements pouvant influencer le cours d'une société cotée.",
    },
    {
      title: "Actualités",
      text: "Informations financières et économiques touchant devises, indices, matières premières et actions.",
    },
    {
      title: "Intelligence IA",
      text: "Analyse, organise et résume les informations disponibles pour faire ressortir l'essentiel et son impact potentiel.",
    },
  ],
  tips: [
    "L'Analyse fondamentale ne donne pas de signaux de trading : elle sert à comprendre le contexte, pas à prédire la direction.",
    "Utilise-la en complément de l'analyse technique pour construire des scénarios plus cohérents.",
    "Vérifie toujours les informations essentielles avant de prendre une décision.",
  ],
  faq: [
    {
      q: "Qu'est-ce que la partie Analyse fondamentale ?",
      a:
        "La partie Analyse fondamentale aide le trader à mieux comprendre les éléments économiques et financiers qui influencent les marchés.\n\n" +
        "Elle centralise plusieurs catégories d'informations pour permettre à l'utilisateur d'avoir une vision plus claire du contexte avant de prendre une décision.",
    },
    {
      q: "Quelles informations retrouve-t-on dans ce module ?",
      a:
        "Le module regroupe principalement :\n" +
        "• les données macroéconomiques\n" +
        "• les informations sur les entreprises\n" +
        "• les actualités financières\n" +
        "• les analyses et synthèses produites avec l'intelligence artificielle",
    },
    {
      q: "À quoi sert la partie Macroéconomie ?",
      a:
        "La partie Macroéconomie permet de suivre les principaux indicateurs économiques susceptibles d'avoir un impact sur les marchés.\n\n" +
        "Elle peut notamment présenter des informations liées à :\n" +
        "• l'inflation\n" +
        "• les taux d'intérêt\n" +
        "• l'emploi\n" +
        "• la croissance économique\n" +
        "• les décisions des banques centrales\n" +
        "• d'autres indicateurs économiques importants\n\n" +
        "Ces données permettent au trader de mieux comprendre le contexte général du marché.",
    },
    {
      q: "À quoi sert la partie Entreprises ?",
      a:
        "La partie Entreprises regroupe des données fondamentales liées aux sociétés cotées.\n\n" +
        "Elle permet notamment de mieux comprendre :\n" +
        "• l'activité d'une entreprise\n" +
        "• ses performances\n" +
        "• ses résultats financiers\n" +
        "• les événements importants qui la concernent\n" +
        "• les éléments pouvant influencer son cours",
    },
    {
      q: "À quoi sert la partie Actualités ?",
      a:
        "La partie Actualités permet de suivre les informations financières et économiques importantes.\n\n" +
        "Elle aide le trader à rester informé sur les événements susceptibles d'influencer :\n" +
        "• les devises\n" +
        "• les indices\n" +
        "• les matières premières\n" +
        "• les actions\n" +
        "• les différents marchés financiers",
    },
    {
      q: "Quel est le rôle de l'Intelligence IA ?",
      a:
        "La partie Intelligence IA analyse, organise et résume les différentes informations disponibles.\n\n" +
        "Elle permet notamment de :\n" +
        "• faire ressortir les éléments importants\n" +
        "• simplifier les données complexes\n" +
        "• relier plusieurs informations entre elles\n" +
        "• mieux comprendre leur impact potentiel sur les marchés\n" +
        "• obtenir une synthèse plus rapide du contexte fondamental",
    },
    {
      q: "À quoi sert concrètement l'Analyse fondamentale pour le trader ?",
      a:
        "Elle peut aider le trader à :\n" +
        "• mieux préparer sa journée de trading\n" +
        "• comprendre pourquoi un marché devient volatil\n" +
        "• identifier les événements importants à surveiller\n" +
        "• éviter de trader sans connaître le contexte économique\n" +
        "• compléter son analyse technique\n" +
        "• construire des scénarios plus cohérents",
    },
    {
      q: "L'Analyse fondamentale donne-t-elle des signaux de trading ?",
      a:
        "Non.\n\n" +
        "Elle fournit des informations, des analyses et des synthèses pour aider l'utilisateur à mieux comprendre le marché.\n\n" +
        "Elle ne garantit pas :\n" +
        "• la direction future du marché\n" +
        "• la réussite d'une position\n" +
        "• un gain\n" +
        "• l'exactitude absolue de chaque interprétation\n\n" +
        "L'utilisateur doit toujours vérifier les informations essentielles et prendre ses propres décisions.",
    },
    {
      q: "L'Analyse IA remplace-t-elle l'analyse du trader ?",
      a:
        "Non.\n\n" +
        "L'intelligence artificielle facilite la lecture et la compréhension des informations, mais elle ne remplace pas :\n" +
        "• l'analyse personnelle\n" +
        "• l'expérience\n" +
        "• la gestion du risque\n" +
        "• la stratégie du trader\n" +
        "• la vérification des sources\n\n" +
        "L'Analyse fondamentale doit être utilisée comme un outil complémentaire.",
    },
    {
      q: "Comment contacter le support ?",
      a:
        "En cas de difficulté avec cette fonctionnalité, nous recommandons de contacter le support FullMargin par WhatsApp pour obtenir une réponse plus rapide.\n\n" +
        "Il est conseillé d'envoyer :\n" +
        "• l'adresse e-mail du compte FullMargin\n" +
        "• une description précise du problème\n" +
        "• la partie du module concernée\n" +
        "• une capture d'écran, si nécessaire",
    },
  ],
  related: ["chat-ia", "strategy-hub", "graphiques-backtest"],
};

export const en = {
  title: "Fundamental analysis",
  tagline: "Macro, companies, news and AI summaries",
  readMin: 5,
  intro:
    "The Fundamental analysis section helps the trader understand the economic and financial elements that move the markets. It centralises several categories of information so you get a clearer view of the context before making a decision.",
  brief: [
    "Follow macro indicators and central bank decisions",
    "Find company data and financial news",
    "Get an AI summary of the fundamental context",
  ],
  steps: [
    {
      title: "Macroeconomics",
      text: "Inflation, interest rates, employment, growth, central bank decisions and other key indicators.",
    },
    {
      title: "Companies",
      text: "Activity, performance, financial results and events that can influence a listed company's price.",
    },
    { title: "News", text: "Financial and economic information affecting currencies, indices, commodities and stocks." },
    {
      title: "AI Intelligence",
      text: "Analyses, organises and summarises the available information to surface what matters and its potential impact.",
    },
  ],
  tips: [
    "Fundamental analysis gives no trading signals: it is there to understand the context, not to predict direction.",
    "Use it alongside technical analysis to build more consistent scenarios.",
    "Always verify essential information before making a decision.",
  ],
  faq: [
    {
      q: "What is the Fundamental analysis section?",
      a:
        "The Fundamental analysis section helps the trader understand the economic and financial elements that move the markets.\n\n" +
        "It centralises several categories of information so you get a clearer view of the context before making a decision.",
    },
    {
      q: "What information does this module contain?",
      a:
        "The module mainly gathers:\n" +
        "• macroeconomic data\n" +
        "• company information\n" +
        "• financial news\n" +
        "• analyses and summaries produced with artificial intelligence",
    },
    {
      q: "What is the Macroeconomics part for?",
      a:
        "The Macroeconomics part follows the main economic indicators likely to impact the markets.\n\n" +
        "It can show information about:\n" +
        "• inflation\n" +
        "• interest rates\n" +
        "• employment\n" +
        "• economic growth\n" +
        "• central bank decisions\n" +
        "• other important economic indicators\n\n" +
        "This data helps the trader understand the general market context.",
    },
    {
      q: "What is the Companies part for?",
      a:
        "The Companies part gathers fundamental data about listed companies.\n\n" +
        "It helps you understand:\n" +
        "• a company's activity\n" +
        "• its performance\n" +
        "• its financial results\n" +
        "• the important events concerning it\n" +
        "• the elements that can influence its price",
    },
    {
      q: "What is the News part for?",
      a:
        "The News part follows important financial and economic information.\n\n" +
        "It helps the trader stay informed about events likely to influence:\n" +
        "• currencies\n" +
        "• indices\n" +
        "• commodities\n" +
        "• stocks\n" +
        "• the various financial markets",
    },
    {
      q: "What is the role of AI Intelligence?",
      a:
        "The AI Intelligence part analyses, organises and summarises the available information.\n\n" +
        "It lets you:\n" +
        "• surface the important elements\n" +
        "• simplify complex data\n" +
        "• connect several pieces of information\n" +
        "• better understand their potential market impact\n" +
        "• get a faster summary of the fundamental context",
    },
    {
      q: "What is fundamental analysis concretely useful for?",
      a:
        "It can help the trader:\n" +
        "• prepare their trading day better\n" +
        "• understand why a market becomes volatile\n" +
        "• identify the important events to watch\n" +
        "• avoid trading without knowing the economic context\n" +
        "• complement their technical analysis\n" +
        "• build more consistent scenarios",
    },
    {
      q: "Does fundamental analysis give trading signals?",
      a:
        "No.\n\n" +
        "It provides information, analysis and summaries to help you understand the market better.\n\n" +
        "It does not guarantee:\n" +
        "• the future direction of the market\n" +
        "• the success of a position\n" +
        "• a profit\n" +
        "• the absolute accuracy of every interpretation\n\n" +
        "You must always verify essential information and make your own decisions.",
    },
    {
      q: "Does the AI Analysis replace the trader's analysis?",
      a:
        "No.\n\n" +
        "AI makes information easier to read and understand, but it replaces neither:\n" +
        "• your own analysis\n" +
        "• experience\n" +
        "• risk management\n" +
        "• the trader's strategy\n" +
        "• source verification\n\n" +
        "Fundamental analysis must be used as a complementary tool.",
    },
    {
      q: "How do I contact support?",
      a:
        "If you run into trouble with this feature, we recommend contacting FullMargin support on WhatsApp for a faster answer.\n\n" +
        "Please send:\n" +
        "• the email address of your FullMargin account\n" +
        "• a precise description of the problem\n" +
        "• the part of the module involved\n" +
        "• a screenshot, if needed",
    },
  ],
  related: ["chat-ia", "strategy-hub", "graphiques-backtest"],
};
